<template>
  <div class="identity-approved">
    <substrate-mount>
      <p v-html="$t('send.new.request.for.refresh.information')"></p>
      <div>
        <cs-button type="secondary" size="small" @click="$emit('reset')">
          {{ $t('notify.about.data.change') }}
        </cs-button>
      </div>
    </substrate-mount>
  </div>
</template>

<script>
import SubstrateMount from '@/components/capusta/SubstrateMount';

export default {
  components: {
    SubstrateMount,
  },
};
</script>

<style lang="sass" scoped>
  .identity-approved
    position: relative

    &:after
      width: 160px
      height: 100%
      position: absolute
      top: 0
      right: 0
      background-position: top -90px right -110px
      background-size: 260px 320px
      background-repeat: no-repeat

      +respond-to('medium')
        content: ''
        background-image: url('~@/assets/svg/identification/approved.svg')
        background-position: top -110px right -130px

  p
    font-weight: 500
    font-size: 14px
    line-height: 20px
    color: #fff
    opacity: .75

    &::v-deep span
      display: block
</style>
